import React, { useState } from "react";
import AttachmentDefault from "../../Create_Assessment/Create_Question/Create_Q_Type/AttachmentDefault";
import ZoomableImage from "../../../../Components/zoomablePic";
import { Box, Paper, Typography, Stack, Chip, Divider } from "@mui/material";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";
import PdfViewer from "../../../../Components/QuestionEditCreate/PdfViewer";

// import "./mcqQuestion.css";
// all css comes in review/McqQuestion.css
const McqQuestion = (para) => {
  const [mideaviewer, setMideaviewer] = useState(false);
  const [responseAttach, setResponseAttach] = useState("");
  const handleClickforpdf = (fileUrl) => {
    setResponseAttach(fileUrl);
    setMideaviewer(true);
  };
  const helper1 = (obj, key, value) => {
    const correctKey = para.currentQuestion.correct_ans.option_key;
    const studentChoiceKey = para.currentQuestion.student_choice.key;
    if (
      para.currentQuestion.correct_ans.option_key ===
      (para.currentQuestion.student_choice.key && key)
    ) {
      return (
        <div className="my-2 options__box_hw options__box_right_hw" style={{ width: "80%" }}>
          <div className="Option">{key}</div>
          {/* <input type="checkbox" checked={true} /> */}
          <img src="/ContentM_images/rightTick.svg" alt="icon" />
          <div className="col Right_optionA_hw" style={{ width: "80%" }}>
            <span className="question_options_hw">{value}.</span>
            <span className="right_Answer_hw">Correct Answer</span>
          </div>
        </div>
      );
    } else if (studentChoiceKey === key && correctKey !== key) {
      return (
        <div className="my-2 options__box_hw options__box_wrong_hw" style={{ width: "80%" }}>
          <div className="Option">{key}</div>
          {/* <input type="checkbox" checked={true}/> */}
          <img src="/ContentM_images/wrongTick.svg" alt="icon" />
          <div className="col Right_optionA_hw">
            <span className="question_options_hw">{value}.</span>
            <span className="wrong_Answer_hw">Student Answer</span>
          </div>
        </div>
      );
    } else if (key !== para.currentQuestion.correct_ans.option_key) {
      return (
        <div className="my-2 options__box_hw" style={{ width: "80%" }}>
          <div className="Option">{key}</div>
          <input type="checkbox" checked={false} />
          <div className="col Right_optionA_hw">
            <span className="question_options_hw">{value}.</span>
          </div>
        </div>
      );
    } else {
      return helper2(obj, key, value);
    }
  };
  const helper2 = (obj, key, value) => {
    if (obj.key !== para.currentQuestion.student_choice.key) {
      return (
        <div className="d-flex gap-1  review_options__box ">
          <div className="Option">{key}</div>
          <input type="checkbox" checked={false} />
          <div className="col Right_optionA_hw">
            <span className="question_options_hw">{value}.</span>
          </div>
        </div>
      );
    }
  };
  // const checkCorrectAnswer = (key) => {
  //   if (response?.question?.correct_answers?.length > 0) {
  //     return response?.question?.correct_answers?.find(
  //       (answer) => answer.option_key === key
  //     );
  //   }
  // };

  // const checkStudentAnswer = (option_key) => {
  //   if (response?.answer) {
  //     return response?.answer?.key === option_key;
  //   }
  // };

  // const matchResultWithResponse = () => {
  //   let result = studentResults.find(
  //     (result) => result?.question_response?.id === response?.id
  //   );
  //   return result;
  // };
  //
  return (
    <Paper
      elevation={0}
      sx={{
        mt: 1,
        p: 2.5,
        borderRadius: 3,
        border: "1px solid #f1c27d",
      }}
    >
      {/* QUESTION HEADER */}
      <Stack direction="row" spacing={1.5} alignItems="flex-start">
        <Typography fontWeight={700} color="#8D4B28">
          Q{para.currentQuestionIndex + 1}.
        </Typography>

        <Typography fontWeight={600} color="#1f2937" lineHeight={1.6}>
          {para.currentQuestion.question_title
            ?.split("\n")
            .map((line, index) => (
              <span key={index}>
                {index !== 0 && <br />}
                {line}
              </span>
            ))}
        </Typography>
      </Stack>

      {/* QUESTION ATTACHMENTS */}
      {para.currentQuestion.attachments?.length > 0 && (
        <Stack direction="row" spacing={2} mt={2} ml={4}>
          {para.currentQuestion.attachments.map((attachment, index) => {
            const ext = attachment.split(".").pop()?.toLowerCase();
            const isImage = ["jpg", "jpeg", "png"].includes(ext);

            return isImage ? (
              <ZoomableImage key={index} src={attachment} />
            ) : (
              <AttachmentDefault
                key={index}
                attach={attachment}
                parasize={para}
                fileSize={para.currentQuestion.attachments_sizeKb[index]}
              />
            );
          })}
        </Stack>
      )}

      <Divider sx={{ my: 2 }} />

      {/* OPTIONS */}
      <Stack spacing={1.5} ml={4}>
        {/* {para.currentQuestion.option.map((obj, index) => (
          <Box key={index}>
            {helper1(obj, obj.key, obj.value)}

            {obj.attachment && (
              <Box mt={1} ml={4}>
                <ZoomableImage src={obj.attachment} />
              </Box>
            )}
          </Box>
        ))} */}
        {para.currentQuestion.option.map((obj, index) => (
          <Box key={index}>
            {helper1(obj, obj.key, obj.value)}

            {obj.attachment && (() => {
              const fileUrl =
                typeof obj.attachment === "string"
                  ? obj.attachment
                  : obj.attachment?.url;

              if (!fileUrl) return null;

              const fileType = fileUrl.split(".").pop().toLowerCase();
              const isImage = ["jpg", "jpeg", "png"].includes(fileType);
              const isVideo = ["mp4", "mov"].includes(fileType);
              const isPdf = fileType === "pdf";

              const fileIcon =
                iconData?.find((i) => i.extension === fileType)?.icon ||
                "/images/file_icon.png";

              const fullUrl = fileUrl.startsWith("http")
                ? fileUrl
                : `${IP}${fileUrl}`;

              return (
                <Box mt={1} ml={4}>
                  <div className="d-flex flex-row align-items-center me-3">
                    {/* ===== Preview ===== */}
                    {isImage ? (
                      <Box mt={1} ml={4}>
                        <ZoomableImage src={obj.attachment} />
                      </Box>
                    ) : isVideo ? (
                      <video
                        src={fullUrl}
                        style={{
                          width: "60px",
                          height: "50px",
                          borderRadius: "6px",
                          marginBottom: "5px",
                        }}
                        controls
                      />
                    ) : isPdf ? (
                      <div
                        onClick={() => handleClickforpdf(fileUrl)}
                        style={{
                          width: "100px",
                          height: "50px",
                          background: "#f5f5f5",
                          borderRadius: "6px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <img
                          src={fileIcon}
                          alt="pdf"
                          style={{ width: "24px", height: "24px" }}
                        />
                        <div className="hw_default_attach_name">
                          <span>{obj.attachment?.replace(/^[^_]*_/, "")}</span>
                        </div>
                      </div>
                    ) : (
                      <a
                        href={`https://docs.google.com/gview?url=${encodeURIComponent(
                          fullUrl
                        )}&embedded=true`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none" }}
                      >
                        <div
                          style={{
                            width: "100px",
                            height: "50px",
                            background: "#f5f5f5",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={fileIcon}
                            alt="file"
                            style={{ width: "24px", height: "24px" }}
                          />
                        </div>
                      </a>
                    )}

                  </div>
                </Box>
              );
            })()}
          </Box>
        ))}


      </Stack>

      {/* ANSWER STATUS */}
      <Box mt={2} ml={4}>
        {para.currentQuestion.student_choice.key !== " " ? (
          para.currentQuestion.student_choice.key !==
          para.currentQuestion.correct_ans.option_key && (
            <Stack direction="row" spacing={1} alignItems="center">
              <img src="/images/wrong_icon.svg" alt="" />
              <Typography fontWeight={600} color="#dc2626">
                Wrong
              </Typography>
            </Stack>
          )
        ) : (
          <Stack direction="row" spacing={1} alignItems="center">
            <img src="/images/wrong_icon.svg" alt="" />
            <Typography fontWeight={600} color="#dc2626">
              Student Not Answered
            </Typography>
          </Stack>
        )}
      </Box>

      {/* TEACHER COMMENT */}
      <Box mt={3}>
        <Typography fontWeight={600} mb={1}>
          Teacher Comment
        </Typography>

        <textarea
          className="remark_textfield_box_hw"
          value={para.currentQuestion.comment}
          readOnly
        />

        <Stack direction="row" spacing={2} mt={2} alignItems="center">
          <Typography>
            Allot marks out of {para.currentQuestion.totalM}
          </Typography>

          <input
            className="score_box_hw px-2"
            type="number"
            value={para.currentQuestion.obtained_marks}
            readOnly
          />
        </Stack>

        {/* CORRECT ANSWER */}
        <Typography fontWeight={600} mt={3}>
          Correct Answer
        </Typography>

        <Box
          mt={1}
          p={1.5}
          borderRadius={2}
          sx={{
            backgroundColor: "#f0fdf4",
            border: "1px solid #16a34a",
          }}
        >
          {para.currentQuestion.correct_ans.option_key}
        </Box>
      </Box>
      {mideaviewer && (
        <PdfViewer
          setMideaviewer={setMideaviewer}
          attachment={responseAttach}
        />
      )}
    </Paper>
  );
};

export default McqQuestion;
